export default "__VITE_ASSET__B5N801u6__"